import { render, staticRenderFns } from "./list-utm.vue?vue&type=template&id=1fc888b5&scoped=true"
import script from "./list-utm.vue?vue&type=script&lang=js"
export * from "./list-utm.vue?vue&type=script&lang=js"
import style0 from "./list-utm.vue?vue&type=style&index=0&id=1fc888b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc888b5",
  null
  
)

export default component.exports